import $ from 'jquery';


export default () => {
    console.log('header');
};



// WEBPACK FOOTER //
// ../views/partials/header/header.js